module.exports = __webpack_public_path__ + "img/gch2@2x.1bec8af9.png";